import React from "react";
import { Link } from "react-router-dom";
import { properties } from "./../properties";

const PropertiesArea = () => {
  return (
    <section className="space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
            <div className="title-area">
              <span className="sec-subtitle">Your Perfect Home Awaits</span>
              <h2 className="sec-title h1">Explore Our Properties</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {properties.map((property) => (
            <div
              key={property.id}
              className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12"
            >
              <div className="destination-style1">
                <Link to={property.link}>
                  <img src={property.imageUrl} alt="property" />
                </Link>
                {/* <span className="destination-price">{property.price}</span> */}
                <div className="destination-info">
                  <h4 className="destination-name">
                    <Link to={property.link}>{property.name}</Link>
                  </h4>
                  <p className="destination-text">{property.description}</p>
                  <p className="destination-location text-white">
                    {property.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertiesArea;
